if (!customElements.get('complementary-product-recommendations-custom')) {
  customElements.define(
    'complementary-product-recommendations-custom',
    class ComplementaryProductRecommendationsCustom extends HTMLElement {
      constructor() {
        super();

        if ('requestIdleCallback' in window) {
          requestIdleCallback(this.init.bind(this), { timeout: 1500 });
        } else {
          FoxTheme.Motion.inView(this, this.init.bind(this), {
            margin: '0px 0px 400px 0px',
          });
        }
      }

      init() {
        if (this.dataset.loaded === 'true') return;
        this.dataset.loaded = 'true';

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((responseText) => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(responseText, 'text/html')
              .querySelector('.shopify-section');

            if (!sectionInnerHTML) return;

            const blockId = this.dataset.blockId;

            const recommendations = sectionInnerHTML.querySelector(
              `complementary-product-recommendations-custom[data-block-id="${blockId}"]`
            );

            if (
              recommendations &&
              recommendations.innerHTML.trim().length
            ) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (recommendations?.querySelector('complementary-product-card')) {
              this.dispatchEvent(
                new CustomEvent('recommendations:loaded')
              );
            } else {
              this.closest('.product__block')?.remove();

              this.dispatchEvent(
                new CustomEvent('recommendations:empty')
              );
            }
          })
          .catch((error) => {
            console.error(error);
            this.dataset.loaded = 'false';
          });
      }
    }
  );
}

if (!customElements.get('complementary-product-card')) {
  customElements.define(
    'complementary-product-card',
    class ComplementaryProductCard extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';

        this.abortController = new AbortController();

        this.variantData = this.querySelector(
          '[data-complementary-variants]'
        );

        this.optionSelects = Array.from(
          this.querySelectorAll('[data-complementary-option]')
        );

        this.variantInput = this.querySelector('input[name="id"]');

        this.addButton = this.querySelector(
          '[data-complementary-add]'
        );

        this.addButtonText = this.querySelector(
          '[data-complementary-add-text]'
        );

        this.priceWrapper = this.querySelector(
          '[data-complementary-price]'
        );

        if (
          !this.variantData ||
          !this.variantInput ||
          !this.addButton
        ) {
          return;
        }

        try {
          this.variants = JSON.parse(
            this.variantData.textContent
          );
        } catch (error) {
          console.error(
            'Complementary product variants could not be parsed.',
            error
          );
          return;
        }

        this.optionSelects.forEach((select) => {
          select.addEventListener(
            'change',
            this.handleVariantChange.bind(this),
            {
              signal: this.abortController.signal,
            }
          );
        });

        this.handleVariantChange();
      }

      disconnectedCallback() {
        this.abortController?.abort();
      }

      handleVariantChange() {
        const selectedOptions = this.optionSelects.map(
          (select) => select.value
        );

        let variant = null;

        if (this.optionSelects.length === 0) {
          variant =
            this.variants.find(
              (candidate) =>
                String(candidate.id) ===
                String(this.variantInput.value)
            ) || this.variants[0];
        } else {
          variant = this.variants.find((candidate) => {
            if (
              candidate.options.length !==
              selectedOptions.length
            ) {
              return false;
            }

            return candidate.options.every(
              (option, index) =>
                option === selectedOptions[index]
            );
          });
        }

        if (!variant) {
          this.variantInput.value = '';
          this.addButton.disabled = true;

          this.setButtonText(
            FoxTheme.variantStrings?.unavailable ||
              'Nicht verfügbar'
          );

          if (this.priceWrapper) {
            this.priceWrapper.hidden = true;
          }

          return;
        }

        this.variantInput.value = variant.id;

        this.variantInput.dispatchEvent(
          new Event('change', { bubbles: true })
        );

        this.addButton.disabled = !variant.available;

        if (variant.available) {
          this.setButtonText(
            this.dataset.addLabel ||
              FoxTheme.variantStrings?.addToCart ||
              'Dazu legen'
          );
        } else {
          this.setButtonText(
            FoxTheme.variantStrings?.soldOut ||
              'Ausverkauft'
          );
        }

        this.updatePrice(variant);
      }

      setButtonText(text) {
        if (this.addButtonText) {
          this.addButtonText.textContent = text;
        }
      }

      updatePrice(variant) {
        if (!this.priceWrapper) return;

        this.priceWrapper.hidden = false;

        const priceElement =
          this.priceWrapper.querySelector('.f-price');

        if (!priceElement) return;

        const price = Number(variant.price || 0);
        const compareAtPrice = Number(
          variant.compare_at_price || 0
        );

        const onSale = compareAtPrice > price;

        const moneyFormat =
          window.FoxTheme?.settings?.moneyFormat;

        const formattedPrice =
          FoxTheme.Currency.formatMoney(
            price,
            moneyFormat
          );

        const formattedCompareAtPrice = onSale
          ? FoxTheme.Currency.formatMoney(
              compareAtPrice,
              moneyFormat
            )
          : '';

        priceElement.classList.toggle(
          'f-price--sold-out',
          !variant.available
        );

        priceElement.classList.toggle(
          'f-price--on-sale',
          onSale
        );

        const regularPrice =
          priceElement.querySelector(
            '.f-price__regular .f-price-item--regular'
          );

        const salePrice =
          priceElement.querySelector(
            '.f-price__sale .f-price-item--sale'
          );

        const comparePrice =
          priceElement.querySelector(
            '.f-price__sale .f-price-item--regular'
          );

        if (regularPrice) {
          regularPrice.textContent = onSale
            ? ''
            : formattedPrice;
        }

        if (salePrice) {
          salePrice.textContent = onSale
            ? formattedPrice
            : '';
        }

        if (comparePrice) {
          comparePrice.innerHTML = onSale
            ? `<s>${formattedCompareAtPrice}</s>`
            : '';
        }
      }
    }
  );
}